import {
  Box,
  Button,
  Modal
} from '@platform/ui-library';
import { FC } from 'react';
import { useServices, useSubject } from '@app/hooks';
import { UploadProgress } from '../UploadProgress';
import { LoadingSpinner } from './LoadingSpinner';
import styles from './LoadingModal.module.scss';

/** Used to display when the @see LoadingService is loading. */
export const LoadingModal: FC = () => {
  const { loadingService } = useServices();
  const isLoading = useSubject(
    loadingService.isLoadingChange,
    loadingService.isLoading
  );
  const { message, onCancel, progress } = useSubject(
    loadingService.messageChange,
    loadingService.message
  ) ?? {};

  return (
    <Modal
      handleClose={() => {
        // The user can not close the loading modal.
      }}
      isOpen={isLoading}
    >
      <Box theme="bigPadding">
        <LoadingSpinner
          hideSpinner={!!progress}
          message={message ?? 'Loading...'}
        />
        {(!progress) ? null : (
          <UploadProgress
            classNames={{ container: styles.progressContainer }}
            {...progress}
          />
        )}
        {(!onCancel) ? null : (
          <div className={styles.actionContainer}>
            <Button
              icon="cross"
              onClick={() => onCancel()}
              theme="secondary"
            >
              Cancel
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};
